import React, { Dispatch, SetStateAction, useState, ChangeEvent } from 'react';
import './textbox.css';
import '../general.css';
export interface LSTextboxProps {
   Value: string;
   setValue: Dispatch<SetStateAction<string>>;
   Placeholder: string;
   ID: string;
   Type?: string;
   ClassN?: string;
   Disabled?: boolean;
   MainColor?: string;
}

const LSTextbox = (props: LSTextboxProps) => {
   const { MainColor = '#069bff', Disabled = false, ClassN, Value, setValue, Placeholder, ID, Type = 'text' } = props;
   //const [text, setText] = useState(Value);
   const enterValue = (event: ChangeEvent) => {
      setValue(event.target.value);
   };
   return (
      <div className={(Value === '' ? 'ams-textbox card-1 ' : 'ams-textbox card-1 hasVal ') + ClassN}>
         <input
            className="useFont"
            onChange={enterValue}
            type={Type}
            name={ID}
            id={ID}
            placeholder={Placeholder}
            value={Value}
            required
            disabled={Disabled}
         />
         <label htmlFor="ams-signup-fn" style={{ backgroundColor: MainColor }}>
            {Placeholder}
         </label>
      </div>
   );
};

export default LSTextbox;
